export default class ExtraPricingModel {
	id = null
	name = null
	junior = 0.0
	senior = 0.0
}